import {
  one_time_pin_styles_default
} from "./chunk.WOWU6DOL.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/one-time-pin/one-time-pin.ts
var FadvOneTimePin = class extends s {
  constructor() {
    super(...arguments);
    this.spaces = 6;
    this.value = "";
  }
  handleKeydown(event) {
    const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (hasModifier || !["Tab", "Backspace", "Enter"].includes(event.key) && !/\d/.test(event.key)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  setValue(value, defaultValue = "") {
    if (value.length >= this.spaces && !RegExp(`\\d{${this.spaces}}`).test(value)) {
      this.input.value = defaultValue;
    } else {
      this.input.value = value;
    }
    this.value = this.input.value;
  }
  firstUpdated() {
    if (this.value) {
      this.setValue(this.value);
    }
  }
  handleValueChange(oldValue, newValue) {
    this.setValue(newValue, oldValue);
  }
  handleInput() {
    this.setValue(this.input.value);
    emit(this, "sl-input", { detail: { value: this.value } });
  }
  handleInputChange() {
    emit(this, "sl-change", { detail: { value: this.value } });
  }
  handleInputFocus() {
    this.focused = true;
    emit(this, "sl-focus");
  }
  handleInputBlur() {
    this.focused = false;
    emit(this, "sl-blur");
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  renderSpace(index) {
    let value = "";
    if (this.value.length > index) {
      value = this.value[index];
    } else if (this.value.length === index) {
      value = $`<div class="one-time-pin__cursor">|</div>`;
    }
    if (this.spaces % 2 === 0 && this.spaces / 2 === index) {
      return $`<div aria-hidden="true" class="one-time-pin__space-blank"></div><div aria-hidden="true" class="one-time-pin__space">${value}</div>`;
    }
    return $`<div aria-hidden="true" class="one-time-pin__space">${value}</div>`;
  }
  render() {
    return $`<form class=${o({
      "one-time-pin": true,
      "one-time-pin--focused": this.focused,
      "one-time-pin--disabled": this.disabled
    })} @click=${this.focus} >${Array.from({ length: this.spaces }).map((_, i2) => this.renderSpace(i2))}<input autocomplete="one-time-code" aria-autocomplete="both" autofocus=${l(this.autofocus || void 0)} @keydown=${this.handleKeydown} @input=${this.handleInput} @blur=${this.handleInputBlur} @focus=${this.handleInputFocus} onselectstart="return false;" onmousedown="return false;" class="one-time-pin__input" type="text" minlength=${this.spaces} maxlength=${this.spaces} .value=${l2(this.value)} ?disabled=${this.disabled} /></form>`;
  }
};
FadvOneTimePin.styles = one_time_pin_styles_default;
__decorateClass([
  e()
], FadvOneTimePin.prototype, "spaces", 2);
__decorateClass([
  e()
], FadvOneTimePin.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvOneTimePin.prototype, "valid", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvOneTimePin.prototype, "invalid", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvOneTimePin.prototype, "disabled", 2);
__decorateClass([
  i(".one-time-pin__input")
], FadvOneTimePin.prototype, "input", 2);
__decorateClass([
  t()
], FadvOneTimePin.prototype, "focused", 2);
__decorateClass([
  watch("value", { waitUntilFirstUpdate: true })
], FadvOneTimePin.prototype, "handleValueChange", 1);
FadvOneTimePin = __decorateClass([
  n("fadv-one-time-pin")
], FadvOneTimePin);

export {
  FadvOneTimePin
};
